
















































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import InputControl from "@/components/Controls/InputControl.vue";
import TextareaControl from "@/components/Controls/TextareaControl.vue";
import PreliminaryReportModel from "@/model/PreliminaryReport";

const UserStore = namespace("User");
const FormStore = namespace("Form");
const AppStore = namespace("App");

@Component({
  name: "PreliminaryReportSummary",
  components: {
    InputControl,
    TextareaControl
  }
})
export default class ReportSummary extends Vue {
  @Prop({ required: true })
  readonly value!: PreliminaryReportModel;

  @FormStore.State
  formDisabled!: boolean;

  private report: PreliminaryReportModel | null = this.value;

  @UserStore.Getter
  public isAdmin!: boolean;

  @UserStore.Getter
  public isUser!: boolean;

  @AppStore.State
  public reportYear!: number;

  @Watch("value") setValue(newValue: PreliminaryReportModel) {
    this.report = newValue;
  }

  created() {
    this.report = this.value;
  }

  touch(validator: any) {
    validator && validator.$touch && validator.$touch();
  }
}
